<template>
  <div class="ourTeam">
    <BreadsCrums page="ourTeam" previous="home" />
    <div v-if="!loading">
      <div class="at-grid" data-column="3" v-if="teams">
        <div class="modal fade" id="myModal" v-if="modalVisible" role="dialog">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  @click="closeModal()"
                  data-dismiss="modal"
                >&times;</button>
                <h4 class="modal-title">{{ modalData.name }}</h4>
              </div>
              <div class="modal-body">
                <div v-html="modalData.bio"></div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="closeModal()"
                  data-dismiss="modal"
                >Close</button>
              </div>
            </div>
          </div>
        </div>
        <div teams v-for="(team, index) in teams" :key="index" class="at-column">
          <div class="at-user">
            <div class="at-user__avatar">
              <img :src="team.image" />
            </div>
            <div class="at-user__name">{{ team.name }}</div>
            <div class="at-user__title">{{ team.position }}</div>
            <a
              class="btn btn-default"
              href="#"
              data-toggle="modal"
              data-target="#myModal"
              @click="openModal(team)"
            >
              <i class="fa fa-eye">{{ $t("view") }}</i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <Loader v-else />
  </div>
</template>

<script>
import Axios from "axios";
import APPURL from "../constant";
export default {
  watch: {
    $route() {
      this.getTeams();
    }
  },
  created() {
    document.title = this.$i18n.t("navBar.ourTeam");
  },
  mounted() {
    this.getTeams();
  },
  data() {
    return {
      teams: {},
      modalVisible: false,
      loading: true
    };
  },
  methods: {
    getTeams(url = APPURL.LINK + "team/" + this.$i18n.locale) {
      Axios.get(url).then(response => {
        this.teams = response.data.data.results;
        this.loading = false;
        //console.log(this.teams);
      });
    },
    openModal(team) {
      this.modalData = team;
      this.modalVisible = true;
    },
    closeModal() {
      this.modalData = {};
      this.modalVisible = false;
    }
  },
  name: "ourTeam"
};
</script>

<style scoped>
/* .modal-content {
  width: 1000px !important;
} */
.at-grid {
  margin-top: -20px !important;
  margin-bottom: 20px;
}
.at-section__title {
  margin: 0 0 70px;
  color: #000;
  font-family: "Roboto", sans-serif;
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 2.625rem;
  text-align: center;
}
.at-grid {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #e2e9ed;
}
.at-grid[data-column="1"] .at-column {
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
}
.at-grid[data-column="2"] .at-column {
  width: 50%;
  max-width: 50%;
  min-width: 50%;
  -ms-flex-preferred-size: 50%;
  flex-basis: 50%;
}
.at-grid[data-column="3"] .at-column {
  width: 33.33333%;
  max-width: 33.33333%;
  min-width: 33.33333%;
  -ms-flex-preferred-size: 33.33333%;
  flex-basis: 33.33333%;
}
.at-grid[data-column="4"] .at-column {
  width: 25%;
  max-width: 25%;
  min-width: 25%;
  -ms-flex-preferred-size: 25%;
  flex-basis: 25%;
}
.at-grid[data-column="5"] .at-column {
  width: 20%;
  max-width: 20%;
  min-width: 20%;
  -ms-flex-preferred-size: 20%;
  flex-basis: 20%;
}
.at-grid[data-column="6"] .at-column {
  width: 16.66667%;
  max-width: 16.66667%;
  min-width: 16.66667%;
  -ms-flex-preferred-size: 16.66667%;
  flex-basis: 16.66667%;
}
.at-grid[data-column="7"] .at-column {
  width: 14.28571%;
  max-width: 14.28571%;
  min-width: 14.28571%;
  -ms-flex-preferred-size: 14.28571%;
  flex-basis: 14.28571%;
}
.at-grid[data-column="8"] .at-column {
  width: 12.5%;
  max-width: 12.5%;
  min-width: 12.5%;
  -ms-flex-preferred-size: 12.5%;
  flex-basis: 12.5%;
}
.at-grid[data-column="9"] .at-column {
  width: 11.11111%;
  max-width: 11.11111%;
  min-width: 11.11111%;
  -ms-flex-preferred-size: 11.11111%;
  flex-basis: 11.11111%;
}
.at-column {
  z-index: 0;
  position: relative;
  background: #ffffff;
  box-shadow: 0 0 0 1px #e2e9ed;
  padding: 10px;
  box-sizing: border-box;
  -webkit-transition: box-shadow 0.2s ease, z-index 0s 0.2s ease,
    -webkit-transform 0.2s ease;
  transition: box-shadow 0.2s ease, z-index 0s 0.2s ease,
    -webkit-transform 0.2s ease;
  transition: box-shadow 0.2s ease, transform 0.2s ease, z-index 0s 0.2s ease;
  transition: box-shadow 0.2s ease, transform 0.2s ease, z-index 0s 0.2s ease,
    -webkit-transform 0.2s ease;
}
.at-column:before {
  content: "";
  display: block;
  padding-top: 100%;
}
.at-column:hover {
  z-index: 1;
  background: #f7f7da;
  box-shadow: 0 8px 50px rgba(0, 0, 0, 0.2);
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
  -webkit-transition: box-shadow 0.2s ease, z-index 0s 0s ease,
    -webkit-transform 0.2s ease;
  transition: box-shadow 0.2s ease, z-index 0s 0s ease,
    -webkit-transform 0.2s ease;
  transition: box-shadow 0.2s ease, transform 0.2s ease, z-index 0s 0s ease;
  transition: box-shadow 0.2s ease, transform 0.2s ease, z-index 0s 0s ease,
    -webkit-transform 0.2s ease;
}
.at-column:hover .at-social {
  margin: 16px 0 0;
  opacity: 1;
}
@media (max-width: 800px) {
  .at-column {
    width: 50% !important;
    max-width: 50% !important;
    min-width: 50% !important;
    -ms-flex-preferred-size: 50% !important;
    flex-basis: 50% !important;
  }
}
@media (max-width: 600px) {
  .at-column {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    -ms-flex-preferred-size: 100% !important;
    flex-basis: 100% !important;
  }
}
.at-user {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  text-align: center;
}
.at-user__avatar {
  width: 200px;
  height: 200px;
  border-radius: 100%;
  margin: 0 auto 20px;
  overflow: hidden;
}
.at-user__avatar img {
  display: block;
  width: 100%;
  max-width: 100%;
}
.at-user__name {
  color: #ef9600;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 500;
  line-height: 2.625rem;
}
.at-user__title {
  color: #00ae00;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  line-height: 2.375rem;
}
.at-social {
  margin: 0 0 -18px;
  opacity: 0;
  -webkit-transition: margin 0.2s ease, opacity 0.2s ease;
  transition: margin 0.2s ease, opacity 0.2s ease;
}
.at-social__item {
  display: inline-block;
  margin: 0 10px;
}
.at-social__item a {
  display: block;
}
.at-social__item svg {
  fill: #515f65;
  display: block;
  height: 18px;
  -webkit-transition: fill 0.2s ease;
  transition: fill 0.2s ease;
}
.at-social__item svg:hover {
  fill: #788d96;
}

@media all {
  .featherlight {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2147483647;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    background: #333;
    background: 0 0;
  }

  .featherlight:last-of-type {
    background: rgba(0, 0, 0, 0.8);
  }

  .featherlight:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .featherlight .featherlight-content {
    position: relative;
    text-align: left;
    vertical-align: middle;
    display: inline-block;
    overflow: auto;
    padding: 25px 25px 0;
    border-bottom: 25px solid transparent;
    margin-left: 5%;
    margin-right: 5%;
    max-height: 95%;
    background: #fff;
    cursor: auto;
    white-space: normal;
  }

  .featherlight .featherlight-inner {
    display: block;
  }

  .featherlight .featherlight-close-icon {
    position: absolute;
    z-index: 9999;
    top: 0;
    right: 0;
    line-height: 25px;
    width: 25px;
    cursor: pointer;
    text-align: center;
    font-family: Arial, sans-serif;
    background: #fff;
    background: rgba(255, 255, 255, 0.3);
    color: #000;
    border: 0;
    padding: 0;
  }

  .featherlight .featherlight-close-icon::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  .featherlight .featherlight-image {
    width: 100%;
  }

  .featherlight-iframe .featherlight-content {
    border-bottom: 0;
    padding: 0;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }

  .featherlight iframe {
    border: 0;
  }

  .featherlight * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
}

@media only screen and (max-width: 1024px) {
  .featherlight .featherlight-content {
    margin-left: 0;
    margin-right: 0;
    max-height: 98%;
    padding: 10px 10px 0;
    border-bottom: 10px solid transparent;
  }
}
</style>
